import { INDEX_OPTIONS, INDEX_STORAGE_KEY } from './constants'
import type { IndexKey } from './constants'

export function loadIndexOverlay(): IndexKey[] {
  try {
    const raw = localStorage.getItem(INDEX_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as string[]
    const valid = INDEX_OPTIONS.map((o) => o.key)
    const filtered = parsed.filter((k): k is IndexKey => valid.includes(k as IndexKey))
    return filtered.slice(0, 3)
  } catch {
    return []
  }
}

export function saveIndexOverlay(keys: IndexKey[]) {
  try {
    localStorage.setItem(INDEX_STORAGE_KEY, JSON.stringify(keys.slice(0, 3)))
  } catch {
    /* ignore */
  }
}
